<div class="snackbar">
  <span class="message">{{ message }}</span>

  <div class="actions" style="margin-left: 30px !important;">
    <button *ngIf="showUndo" class="undo" (click)="undo()">{{ctaText || 'Undo'}}</button>
    <button *ngIf="showClose" class="close" (click)="close()">×</button>
  </div>
</div>
